export default "__VITE_ASSET__96dd7738__"